import {registerPortalRoot} from '@primer/react'
import {useCallback} from 'react'
import {createPortal} from 'react-dom'

// Mirrors `SIDE_PANEL_PORTAL_ROOT` in `@github-ui/side-panel`. Inlined here
// to avoid taking a new cross-package dep for a single string.
export const SIDE_PANEL_PORTAL_ROOT_NAME = 'sidePanelPortalRoot'

/**
 * The Workbench renders the issue viewer with `insideSidePanel: true` for
 * layout/scroll behavior, but doesn't actually wrap it in a `<SidePanel>`,
 * so the `sidePanelPortalRoot` portal name `IssueBody` expects is never
 * registered. Opening the kebab menu then throws and the surrounding error
 * boundary shows "Couldn't load, try again".
 *
 * This component registers a div under that name so the menu has somewhere
 * to portal into. The div is appended directly to `document.body` via
 * `createPortal` so the menu escapes the chat preview container's
 * overflow/stacking context (a first pass mounted the div inline and the
 * menu opened into a clipped node, so visually nothing happened).
 *
 * See github/copilot-experiences#11251.
 */
export function IssuePreviewSidePanelPortal() {
  const registerRef = useCallback((node: HTMLDivElement | null) => {
    if (node) registerPortalRoot(node, SIDE_PANEL_PORTAL_ROOT_NAME)
  }, [])

  return createPortal(<div ref={registerRef} />, document.body)
}
